<template>
  <div class="fileDropAreaSignature">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="s-header" v-bind:style="styletitle">
            <span class="s-title">{{ this.Title }}</span>
            <div class="btn-group btn-group-sm float-sm-right" role="group" aria-label="Signature options">
              <b-button v-if="!isReady" size="sm" @click="getSignatureDefault"
                class="table-title-btn">{{ `Connect` }}</b-button>
              <b-button v-if="isSigning" size="sm" @click="signature_retry_send" class="table-title-btn">{{
                `Clear` }}</b-button>
            </div>
          </div>
          <canvas ref="sigCanvas" width="320" height="160"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { STPadServerLibCommons, STPadServerLibDefault } from '@/assets/js/STPadServerLib-3.5.0.js';

const wsUrl = "wss://localhost:49494";

const OS_WINDOWS = "Windows";
const OS_LINUX = "Linux";

const padStates = {
  closed: 0,
  opened: 1
};

const deviceCapabilities = {
  HasColorDisplay: 0x00000001,
  HasBacklight: 0x00000002,
  SupportsVerticalScrolling: 0x00000004,
  SupportsHorizontalScrolling: 0x00000008,
  SupportsPenScrolling: 0x00000010,
  SupportsServiceMenu: 0x00000020,
  SupportsRSA: 0x00000040,
  SupportsContentSigning: 0x00000080,
  SupportsH2ContentSigning: 0x00000100,
  CanGenerateSignKey: 0x00000200,
  CanStoreSignKey: 0x00000400,
  CanStoreEncryptKey: 0x00000800,
  CanSignExternalHash: 0x00001000,
  SupportsRSAPassword: 0x00002000,
  SupportsSecureModePassword: 0x00004000,
  Supports4096BitKeys: 0x00008000,
  HasNFCReader: 0x00010000,
  SupportsKeyPad: 0x00020000,
  SupportsKeyPad32: 0x00040000,
  HasDisplay: 0x00080000,
  SupportsRSASignPassword: 0x00100000
};

const PEN_COLOR_GREY = "0x007f7f7f";
const PEN_COLOR_RED = "0x000000ff";
const PEN_COLOR_GREEN = "0x0000ff00";
const PEN_COLOR_BLUE = "0x00ff0000";
const PEN_COLOR_BLACK = "0x00000000";

const signaturePenColorSelect = "0x00000000";

const docHashes = {
  kSha1: 0,
  kSha256: 1
};

export default {
  name: 'MdSignotec',

  props: {
    Title: String
  },

  data() {
    return {
      isReady: false,
      isSigning: false,
      signatureImage: null,
      padIndex: 0,
      os: "Unknown",
      supportsRSA: false,
      canStoreEncryptKey: false,
      padState: padStates.closed,
      sampleRate: 0,
      field_name: "Signature 1",
      custom_text: "Please sign!",
      confirmation_text: "Confirmation Text",
      docHash_type: docHashes.kSha256,
      default_dochash: "",
      sha1_dochash: "AAECAwQFBgcICQoLDA0ODxAREhM=",
      sha256_dochash: "AAECAwQFBgcICQoLDA0ODxAREhMUFRYXGBkaGxwdHh8=",
      encryption_cert: "MIICqTCCAZGgAwIBAgIBATANBgkqhkiG9w0BAQUFADAYMRYwFAYDVQQKEw1EZW1vIHNpZ25vdGVjMB4XDTE1MTAwNzA5NDc1MFoXDTI1MTAwNDA5NDc1MFowGDEWMBQGA1UEChMNRGVtbyBzaWdub3RlYzCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBAOFFpsZexYW28Neznn26Bp9NVCJywFFj1QYXg3DDsaSyr6ubuqXKSC4jkenIGBnom/zKPxwPDtNXuy+nyDYFXYNn87TUdh/51CCr3uk9kR9hvRIzBKwkOx0DGLdCoSGAKDOPHwx1rE0m/SOqYOQh6XFjlybw+KzDZcPvhf2Fq/IFNXHpk8m0YHMAReW8q34CYjk9ZtcIlrcYGTikQherOtYM8CaEUPDd6vdJgosGWEnDeNXDCAIWTFc5ECJm9Hh7a47eF3BG5Pjl1QfOSA8lQBV5eTjQc1n1rWCWULt143nIbN5yCFrn0D8W6+eKJV5urETxWUQ208iqgeU1bIgKSEUCAwEAATANBgkqhkiG9w0BAQUFAAOCAQEAt2ax8iwLFoOmlAOZTQcRQtjxseQAhgOTYL/vEP14rPZhF1/gkI9ZzhESdkqR8mHIIl7FnfBg9A2v9ZccC7YgRb4bCXNzv6TIEyz4EYXNkIq8EaaQpvsX4+A5jKIP0PRNZUaLJaDRcQZudd6FMyHxrHtCUTEvORzrgGtRnhBDhAMiSDmQ958t8RhET6HL8C7EnL7f8XBMMFR5sDC60iCu/HeIUkCnx/a2waZ13QvhEIeUBmTRi9gEjZEsGd1iZmgf8OapTjefZMXlbl7CJBymKPJgXFe5mD9/yEMFKNRy5Xfl3cB2gJka4wct6PSIzcQVPaCts6I0V9NfEikXy1bpSA==",
      encryption_cert_only_when_empty: "TRUE",
      rsa_scheme: STPadServerLibDefault.RsaScheme.PSS,
      sigcanvas: null,
      scaleFactorX: 1.0,
      scaleFactorY: 1.0,
      styletitle: {
        position: 'absolute',
        width: 451 + 'px',
        // top: this.$attrs.control.controlTop+'px',
        // left: this.$attrs.control.controlLeft+'px'
      },
    };
  },

  async mounted() {
    this.sigcanvas = this.$refs.sigCanvas;
    try {
      this.connectToWebsocket();
    } catch (error) {
      console.error("Initialization failed:", error);
    }
    STPadServerLibCommons.handleNextSignaturePoint = (x, y, p) => {
      this.signature_point_send(x, y, p);
    };
    STPadServerLibDefault.handleConfirmSignature = () => {
      this.signature_confirm_send();
    };
    STPadServerLibDefault.handleCancelSignature = () => {
      this.signature_cancel_send();
    };
    STPadServerLibDefault.handleRetrySignature = () => {
      this.signature_retry_send();
    };
    STPadServerLibDefault.handleError = function (error_context, return_code, error_description) {
      this.error_send(error_context, return_code, error_description);
    };
    STPadServerLibCommons.handleDisconnect = function (index) {
      this.disconnect_send(index);
    };    
  },

  beforeDestroy() {
    this.default_close_pad();
    STPadServerLibCommons.destroyConnection();
  },

  methods: {

    // 2. Establish WebSocket bridge to the local service
    connectToWebsocket() {
      const onOpen = () => {
        this.get_server_version();
        this.getSignatureDefault();        
      };
      const onClose = () => {
        this.isReady = false;
      };
      const onError = (err) => {
        this.isReady = false;
        console.error("WebSocket Error:", err);
      };

      STPadServerLibCommons.handleLogging = this.logMessage;
      STPadServerLibCommons.createConnection(wsUrl, onOpen, onClose, onError);
    },

    async get_server_version() {
      try {
        const serverVersion = await STPadServerLibCommons.getServerVersion();
        this.os = serverVersion.os;
        //set_states_of_ui_elements();
      } catch (error) {
        console.log(error.errorMessage);
      }
    },

    async default_close_pad() {
      this.isSigning = false;
      this.isReady = false;
      if (this.padState == padStates.opened) {
        try {
          var closePadParams = new STPadServerLibDefault.Params.closePad(this.padIndex);
          await STPadServerLibDefault.closePad(closePadParams);
          this.padState = padStates.closed;
        } catch (error) {
          this.handleError(error);
        }
      }
    },

    async getSignatureDefault() {
      // search for pads begin
      try {
        var searchForPadsParams = new STPadServerLibDefault.Params.searchForPads();
        var padConnectionType = 'HID';
        searchForPadsParams.setPadSubset(padConnectionType);
        const pads = await STPadServerLibDefault.searchForPads(searchForPadsParams);
        if (pads.foundPads.length == 0) {
          this.$emit('OnSignotecError', "No connected pads have been found.");
          return;
        }
        if (pads.foundPads[this.padIndex].capabilities & deviceCapabilities.SupportsRSA) {
          if (this.os == OS_WINDOWS) {
            this.supportsRSA = true;
          }
          else if (this.os == OS_LINUX) {
            // not supported
            this.supportsRSA = false;
          }
          else {
            // do nothing
          }
        } else {
          this.supportsRSA = false;
        }
        if (pads.foundPads[this.padIndex].capabilities & deviceCapabilities.CanStoreEncryptKey) {
          if (this.os == OS_WINDOWS) {
            this.canStoreEncryptKey = true;
          }
          else if (this.os == OS_LINUX) {
            // not supported
            this.canStoreEncryptKey = false;
          }
          else {
            // do nothing
          }
        }
        else {
          this.canStoreEncryptKey = false;
        }
      } catch (error) {
        this.handleError(error);
        this.default_close_pad();
      }
      // search for pads end

      // open pad begin
      try {
        const openPadParams = new STPadServerLibDefault.Params.openPad(this.padIndex);
        const padInfo = await STPadServerLibDefault.openPad(openPadParams);
        this.padState = padStates.opened;
        this.isReady = true;

        this.sigcanvas.width = padInfo.padInfo.displayWidth;
        this.sigcanvas.height = padInfo.padInfo.displayHeight;

        //get scale factor from signature resolution to canvas
        this.scaleFactorX = padInfo.padInfo.displayWidth / padInfo.padInfo.xResolution;
        this.scaleFactorY = padInfo.padInfo.displayHeight / padInfo.padInfo.yResolution;

        //get sample rate
        this.sampleRate = padInfo.padInfo.samplingRate;

        //start the signature process
        //selection_dialog();
        this.signature_start();
      } catch (error) {
        console.log(error);
        this.default_close_pad();
      }
      // open pad end
    },
    // getSignatureDefault end

    async signature_start() {
      switch (this.docHash_type) {
        case docHashes.kSha1:
          this.default_dochash = this.sha1_dochash;
          break;
        case docHashes.kSha256:
          this.default_dochash = this.sha256_dochash;
          break;
        default:
          console.log("unknown doc hash");
          return;
      }

      try {
        var startSignatureParams = new STPadServerLibDefault.Params.startSignature();
        //startSignatureParams.setFieldName(this.field_name);
        //startSignatureParams.setCustomText(this.custom_text);
        //startSignatureParams.setConfirmationText(this.confirmation_text);
        if (this.supportsRSA) {
          if (this.canStoreEncryptKey) {
            startSignatureParams.enablePadEncryption(this.default_dochash, this.encryption_cert, this.encryption_cert_only_when_empty);
          } else {
            startSignatureParams.enablePadEncryption(this.default_dochash, null);
          }
        }
        await STPadServerLibDefault.startSignature(startSignatureParams);
        this.isSigning = true;
      } catch (error) {
        this.handleError(error);
        this.default_close_pad();
      }
    },
    // signature start end

    signature_point_send(x, y, p) {
      var ctx = this.sigcanvas.getContext("2d");

      ctx.fillStyle = "#fff";

      switch (signaturePenColorSelect) {
        case PEN_COLOR_GREY:
          ctx.strokeStyle = "#7F7F7F";
          break;

        case PEN_COLOR_RED:
          ctx.strokeStyle = "#FF0000";
          break;

        case PEN_COLOR_GREEN:
          ctx.strokeStyle = "#00FF00";
          break;

        case PEN_COLOR_BLUE:
          ctx.strokeStyle = "#0000FF";
          break;

        case PEN_COLOR_BLACK:
          ctx.strokeStyle = "#000000";
          break;

        default:
          ctx.strokeStyle = "#FF0000";
          break;
      }

      ctx.lineWidth = 4.5;
      ctx.lineCap = "round";

      if (p == 0) {
        this.drawStrokeStartPoint(ctx, x * this.scaleFactorX, y * this.scaleFactorY);
      }
      else {
        this.drawStrokePoint(ctx, x * this.scaleFactorX, y * this.scaleFactorY);
      }
    },
    // signature point send end

    /**
    * Draws a stroke start point into the canvas
    */
    drawStrokeStartPoint(canvasContext, softCoordX, softCoordY) {
      // open new stroke's path
      canvasContext.beginPath();
      canvasContext.arc(softCoordX, softCoordY, 0.1, 0, 2 * Math.PI, true);
      canvasContext.fill();
      canvasContext.stroke();
      canvasContext.moveTo(softCoordX, softCoordY);
    },

    /**
    * Draws a stroke point into the canvas
    */
    drawStrokePoint(canvasContext, softCoordX, softCoordY) {
      // continue after start or not start point
      canvasContext.lineTo(softCoordX, softCoordY);
      canvasContext.stroke();
    },

    confirm() {
      this.signature_confirm_send();
    },

    async signature_confirm_send() {
      try {
        const signature = await STPadServerLibDefault.confirmSignature();
        // check if there are enough points for a valid signature
        if ((signature.countedPoints / this.sampleRate) <= 0.2) {
          this.$emit('OnSignotecError', "The signature is too short. Please sign again!");
          await STPadServerLibDefault.retrySignature();
          const ctx = this.sigcanvas.getContext("2d");
          ctx.clearRect(0, 0, this.sigcanvas.width, this.sigcanvas.height);
          return;
        } else if (this.supportsRSA) {
          const signingCert = await STPadServerLibDefault.getSigningCert();
          //document.getElementById("signatureCert_0").innerHTML = signingCert.signingCert;
          this.$emit('OnSignotecSubmitSigningCert', signingCert.signingCert);
        }
        else {
          //document.getElementById("signatureCert_0").innerHTML = "";
        }
      } catch (error) {
        this.handleError(error);
        this.default_close_pad();
      }
      try {
        if (this.os == OS_WINDOWS) {
          var getSignatureImageParams = new STPadServerLibDefault.Params.getSignatureImage();
          getSignatureImageParams.setFileType(STPadServerLibDefault.FileType.PNG);
          getSignatureImageParams.setPenWidth(5);
          const signatureImage = await STPadServerLibDefault.getSignatureImage(getSignatureImageParams);
          //document.getElementById("Signature_0").src = "data:image/png;base64," + signatureImage.file;
          this.$emit('OnSignotecSubmitImage', signatureImage.file);
          this.loadSignature(signatureImage.file);
        }
      } catch (error) {
        this.handleError(error);
        this.default_close_pad();
      }
      try {
        var getSignatureDataParams = new STPadServerLibDefault.Params.getSignatureData();
        getSignatureDataParams.setRsaScheme(this.rsa_scheme);
        const signatureData = await STPadServerLibDefault.getSignatureData(getSignatureDataParams);
        if (this.supportsRSA) {
          if (signatureData.certId !== undefined) {
            //document.getElementById("biometryCertID_0").innerHTML = signatureData.certId;
          }
          document.getElementById("RSAScheme_0").innerHTML = this.rsa_scheme;
          if (signatureData.rsaSignature !== undefined) {
            //document.getElementById("RsaSignature_0").value = signatureData.rsaSignature;
          }
        }
        else {
          //document.getElementById("biometryCertID_0").innerHTML = "";
          //document.getElementById("RSAScheme_0").innerHTML = "";
          //document.getElementById("RsaSignature_0").value = "";
        }
        if (signatureData.signData !== undefined) {
          //document.getElementById("SignData_0").value = signatureData.signData;
          this.$emit('OnSignotecSubmitSignData', signatureData.signData);
        }
      } catch (error) {
        this.handleError(error);
        this.default_close_pad();
      }
      this.default_close_pad();
      this.$emit('OnSignotecConfirm');
    },

    async signature_cancel_send() {
      try {
        await STPadServerLibDefault.cancelSignature();
        var ctx = this.sigcanvas.getContext("2d");
        ctx.clearRect(0, 0, this.sigcanvas.width, this.sigcanvas.height);
        this.default_close_pad();
      } catch (error) {
        this.handleError(error);
        this.default_close_pad();
      }
      this.$emit('OnSignotecCancel');
    },

    async signature_retry_send() {
      try {
        await STPadServerLibDefault.retrySignature();
        var ctx = this.sigcanvas.getContext("2d");
        ctx.clearRect(0, 0, this.sigcanvas.width, this.sigcanvas.height);
      } catch (error) {
        this.handleError(error);
        this.default_close_pad();
      }
    },

    handleError(param) {
      if (param.errorCode < 0) {
        const message = "Function " + param.command + " failed. Reason: " + param.errorMessage;
        STPadServerLibCommons.handleLogging(message);
        console.log(message);
      }
    },

    logMessage() {
    },

    disconnect_send(index) {
      var msg = "The pad (index: " + index + ") has been disconnected.";
      console.log(msg);

      //resetUserInterface();
      this.padState = padStates.closed;
    },

    loadSignature(base64) {
      const ctx = this.sigcanvas.getContext("2d");

      const img = new Image()
      img.onload = () => {
        // clear previous drawing
        ctx.clearRect(0, 0, this.sigcanvas.width, this.sigcanvas.height)

        // draw scaled to canvas size
        ctx.drawImage(img, 0, 0, this.sigcanvas.width, this.sigcanvas.height)
      }

      img.src = "data:image/png;base64," + base64
    }

  }
}
</script>

<style>
.ng-invalid {
  border: 1px solid red !important;
}

.AutoHeightContainerMoreFiles {
  height: calc(100% + 250px) !important;
}

.AutoHeightContainerMinusFiles {
  height: 550px !important;
}

.fileDropArea {
  height: calc(100vh - 224px) !important;
}
</style>
